import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { http } from '../../redux/http';
import { GetProductBucketCap } from '../../redux/constants/apiConstants';
import { Waiting } from '../../components';
import { toast } from 'react-toastify';
import { toolTip } from '../../utils/icons';

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 0px 0 20px;
`;

const Card = styled.div`
  width: calc(25% - 15px);
  background: #FEFEFE;
  border-radius: 12px;
  border: 0.75px solid #DCDCDC;
  padding: 16px;
  box-sizing: border-box;
  position: relative;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const IconBox = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #052838;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 28px;
    height: 28px;
    filter: brightness(0) invert(1);
  }
`;

const ProductName = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  color: #184A61;
  flex: 1;
  margin-left: 12px;
`;

const TooltipWrapper = styled.div`
  position: relative;
  cursor: pointer;
  &:hover .tooltip-text {
    display: block;
  }
  .tooltip-text {
    display: none;
    position: absolute;
    right: -60px;
    bottom: -85px;
    background: #fefefe;
    color: #184a61;
    border: 0.75px solid #DCDCDC;
    font-size: 14px;
    font-family: Lato;
    padding: 10px 12px;
    border-radius: 6px;
    white-space: nowrap;
    z-index: 10;
    width: 300px;
    white-space: normal;
    text-align: center;
    line-height: 18px;
    &::after {
          content: '';
    position: absolute;
    top: -20px;
    right: 62px;
    border-width: 10px;
    border-style: solid;
    border-color: #dcdcdc99 transparent transparent transparent;
    transform: rotate(180deg);
    }
  }
`;


const Divider = styled.hr`
  border: none;
  border-top: 1px solid #DCDCDC;
  margin: 12px 0;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const Label = styled.div`
  font-family: Lato;
  font-size: 16px;
  color: #184A61;
`;

const Value = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  color: #184A61;
`;

class BucketCaps extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null, loading: true };
  }

  async componentDidMount() {
    const { rewardPeriodId } = this.props;
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(
        `${GetProductBucketCap}?reward_period_id=${rewardPeriodId}`,
        { headers: { AUTHTOKEN: AuthToken } }
      );
      this.setState({ data: res.buckets || [], loading: false });
    } catch (e) {
      toast.error(e.message);
      this.setState({ loading: false });
    }
  }




  render() {
    const { data, loading } = this.state;
    if (loading) return <Waiting />;
    if (!data || !data.length) {
      return <div style={{ padding: '20px', color: '#989898', fontFamily: 'Lato' }}>No bucket cap data available.</div>;
    }
    return (

      <Grid>
        <div style={{width:'100%',  fontFamily:'Lato', fontSize:'18px', color:'#184A61', fontWeight:'700'}}>Product Bucket Cap</div>
        {data.map((item, i) => (
          <Card key={i}>
            <CardHeader>
              <IconBox>
                {item.icon ? <img src={item.icon} alt={item.product_name} /> : null}
              </IconBox>
              <ProductName>{item.product_name}</ProductName>
              {item.product_name !== 'Fitness' && (
                <TooltipWrapper>
                  {toolTip()}
                  <div className="tooltip-text">
                        You&apos;ll receive points based on the bucket cap not the total points earned within a specific module.
                  </div>
                </TooltipWrapper>
              )}
            </CardHeader>

            <Divider />
            <div className='bg-div' style={{background:'#F8F8F8', padding:'8px', borderRadius:'4px'}}>
              <Row>
                <Label>Total Points Earned</Label>
                <Value>{item.total_points_earned_without_cap}</Value>
              </Row>
              <Row>
                <Label>Bucket Cap</Label>
                <Value>{item.bucket_cap}</Value>
              </Row>
            </div>
          </Card>
        ))}
      </Grid>
    );
  }
}

BucketCaps.propTypes = {
  rewardPeriodId: PropTypes.number,
};

export default BucketCaps;
